<template>
  <div>
    <div
      class="goodsManageSet"
      :class="{ fixedStyle: isShowStyle }"
      :style="{ top: scrollTop + 'px' }"
    >
      <div class="main_content">
        <div class="tit">新增（编辑）属性标签</div>
        <div class="block">
          <h1>属性标签缩略图</h1>
          <p class="red">JPG或者PNG格式，尺寸比例为500*500像素</p>
          <div class="img_box">
            <van-uploader
              v-model="fileList"
              @click-upload="clickUpload(0)"
              @delete="deleteImg(0)"
              :before-read="beforeRead"
              :after-read="afterRead"
              :max-count="1"
            />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>选择属性标签</h1>
          <div class="input_box flex-between" @click="handlePopup(1)">
            <van-field
              v-model="attrName"
              placeholder="请选择属性标签"
              readonly
            />
            <i class="iconfont icon-bottom"></i>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>设置属性标签值</h1>
          <div class="input_box flex-between">
            <!-- <div class="input_box flex-between" @click="handlePopup(2)"> -->
            <van-field
              v-model="formData.attrvalue"
              placeholder="请设置属性标签值"
            />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>Ai辅助图设置</h1>
          <div class="ai_images_wrap flex-between">
            <div class="ai_images_item">
              <p>产品正面</p>
              <div class="img_box">
                <van-uploader
                  v-model="fileList1"
                  @click-upload="clickUpload(1)"
                  @delete="deleteImg(1)"
                  :before-read="beforeRead"
                  :after-read="afterRead"
                  :max-count="1"
                />
              </div>
            </div>
            <div class="ai_images_item">
              <p>产品背面</p>
              <div class="img_box">
                <van-uploader
                  v-model="fileList2"
                  @click-upload="clickUpload(2)"
                  @delete="deleteImg(2)"
                  :before-read="beforeRead"
                  :after-read="afterRead"
                  :max-count="1"
                />
              </div>
            </div>
            <div class="ai_images_item">
              <p>产品局部细节</p>
              <div class="img_box">
                <van-uploader
                  v-model="fileList3"
                  @click-upload="clickUpload(3)"
                  @delete="deleteImg(3)"
                  :before-read="beforeRead"
                  :after-read="afterRead"
                  :max-count="1"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>设置价格变动值</h1>
          <div class="radio_box" style="margin-bottom: 20px">
            <van-radio-group
              direction="horizontal"
              v-model="formData.numtype"
              style="justify-content: space-evenly"
              @change="handleNumType"
            >
              <van-radio name="不变">不变</van-radio>
              <van-radio name="增加">增加</van-radio>
              <!-- <van-radio name="减少">减少</van-radio> -->
            </van-radio-group>
          </div>
          <div
            class="input_box"
            v-if="
              formData.numtype == '不变' ||
              formData.numtype == '增加' ||
              formData.numtype == '减少'
            "
          >
            <van-field
              v-model="formData.num"
              :readonly="formData.numtype == '不变' ? true : false"
              placeholder="请输入价格变动值"
              @focus="inputFocus"
              @blur="inputBlur"
              maxlength="10"
              @input="handleInputPrice"
            />
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>是否重点标签</h1>
          <div class="radio_box">
            <van-radio-group
              direction="horizontal"
              v-model="formData.isheavy"
              style="justify-content: space-evenly"
            >
              <van-radio :name="true">是</van-radio>
              <van-radio :name="false">否 </van-radio>
            </van-radio-group>
          </div>
        </div>

        <div class="block">
          <h1><span class="mark">*</span>属性标签状态</h1>
          <div class="radio_box">
            <van-radio-group
              direction="horizontal"
              v-model="formData.isuse"
              style="justify-content: space-evenly"
            >
              <van-radio :name="true">启用</van-radio>
              <van-radio :name="false">停用 </van-radio>
            </van-radio-group>
          </div>
        </div>
      </div>

      <div class="primary-button" @click="query">保存确认</div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div>
    </div>

    <van-popup v-model="isShow" round position="bottom" class="brandPopup">
      <template v-if="popupType == 1">
        <van-picker
          title="请选择属性标签"
          show-toolbar
          :columns="attrList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 2">
        <van-picker
          title="请选择标签值"
          show-toolbar
          :columns="attrValueList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import {
  getAttrLabelList,
  getAttrLabelValue,
  uploadImage,
  // editCommondityLabel,
  // addCommondityLabel,
  // getCommondityLabelDetail,
  encryptstringview,
} from "../../../api/api";
import {
  getShopCommodityAttrView,
  addShopCommodityAttr,
  editShopCommodityAttr,
} from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cAttrLabelSet",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      // 弹窗
      popupType: 1,
      isShow: false,
      attrList: [],
      attrValueList: [],

      attrId: "",
      firstIndex: "",
      secondIndex: "",
      fileList: [],
      fileList1: [],
      fileList2: [],
      fileList3: [],

      id: "", // 属性id
      attrName: "", // 属性标签
      labelNum: "", // 商品价格
      labeltype: "", // 商品类型
      formData: {
        cmid: "", // 商品id
        attrid: "",
        attrvalue: "",
        numtype: "",
        num: "",
        pic: "",
        isheavy: false,
        isuse: true,
      },

      isType: 0,
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { cmId, id } = JSON.parse(res.jsondata);
        this.formData.cmid = cmId;
        this.id = id;
        if (id) {
          this.getDetail();
        } else {
          this.getAtrrList();
        }
      } else {
        this.$router.back();
      }
    },

    getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { id } = this;
      getShopCommodityAttrView({ id }).then((res) => {
        this.formData = res;
        this.labeltype = res.numtype;
        this.labelNum = res.num;
        if (res.pic) {
          this.fileList.push({
            url: res.pic,
          });
        }
        if (res.aipic1) {
          this.fileList1.push({
            url: res.aipic1,
          });
        }
        if (res.aipic2) {
          this.fileList2.push({
            url: res.aipic2,
          });
        }
        if (res.aipic3) {
          this.fileList3.push({
            url: res.aipic3,
          });
        }
        if (res.attrid) {
          this.getAtrrList(res.attrid);
        }
        this.formData.aipic1 = res.aipic1 ? res.aipic1 : "";
        this.formData.aipic2 = res.aipic2 ? res.aipic2 : "";
        this.formData.aipic3 = res.aipic3 ? res.aipic3 : "";
        Toast.clear();
      });
    },

    handlePopup(type) {
      let { attrList, attrName } = this;
      this.popupType = type;
      if (type == 1) {
        if (attrList.length == 0) {
          this.$toast("暂无属性标签");
          return;
        }
        this.isShow = true;
      } else if (type == 2) {
        if (attrName == "") {
          this.$toast("请选择属性标签");
          return;
        }
        this.isShow = true;
      }
    },
    // 显示弹窗
    onConfirm(e) {
      let { popupType } = this;
      let { value, text } = e;
      if (popupType == 1) {
        this.attrName = text;
        this.formData.attrid = value;
        this.formData.attrvalue = "";
        // this.getAtrrValueList(value);
      } else if (popupType == 2) {
        this.formData.attrvalue = value;
      }
      this.isShow = false;
    },

    // 获取属性标签
    getAtrrList(attrid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getAttrLabelList().then((res) => {
        let newArr = [];
        let filter = res.filter((v) => v.attrstate == "启用");
        filter.forEach((v) => {
          if (attrid == v.id) {
            this.formData.attrid = attrid;
            this.attrName = v.attrname;
          }
          newArr.push({
            text: v.attrname,
            value: v.id,
          });
        });
        if (attrid) {
          this.getAtrrValueList(attrid);
        }
        this.attrList = newArr;
        Toast.clear();
      });
    },
    // 获取属性标签值
    getAtrrValueList(attrid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getAttrLabelValue().then((res) => {
        let newArr = [];
        res.forEach((v) => {
          if (v.attrid == attrid) {
            newArr.push({
              text: v.attrvalue,
              value: v.attrvalue,
            });
          }
        });

        this.attrValueList = newArr;
        Toast.clear();
      });
    },
    // 价格变动
    handleNumType(event) {
      let { numtype } = this.formData;
      let { labelNum, labeltype } = this;
      if (event == "不变") {
        this.formData.num = 0;
      } else {
        if (labeltype == numtype && labelNum != "") {
          this.formData.num = labelNum;
        } else if (labeltype == numtype && labelNum != "") {
          this.formData.num = labelNum;
        } else {
          this.formData.num = "";
        }
      }
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    // 输入框限制
    handleInputPrice(event) {
      // 只允许输入数字和小数点
      let value = event.replace(/[^\d.]/g, "");
      // 限制只能输入一个小数点
      value = value.replace(/^\./, "").replace(/\.{2,}/g, ".");
      // 截取小数点后两位
      value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      this.formData.num = value;
    },
    handleReturn() {
      history.back();
    },

    // 图片上传
    clickUpload(type) {
      this.isType = type;
    },
    // 删除图片
    deleteImg(isType) {
      if (isType == 0) {
        this.formData.pic = "";
      } else if (isType == 1) {
        this.formData.aipic1 = "";
      } else if (isType == 2) {
        this.formData.aipic2 = "";
      } else if (isType == 3) {
        this.formData.aipic3 = "";
      }
    },

    // 图片上传之前处理
    beforeRead(file) {
      const imgformat = /image\/(png|jpg|jpeg)$/;
      if (!imgformat.test(file.type)) {
        this.$toast.fail("请上传 jpg/png 格式图片");
        return false;
      }
      return true;
    },
    // 检测图片的宽高
    checkWidthAndHeight(file) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = function () {
          let width = img.width;
          var height = img.height;
          if (width == 500 && height == 500) {
            reject(true);
          } else {
            resolve(false);
          }
        };
      });
    },
    // 图片上传后处理
    afterRead(e) {
      let {isType} = this
      var formData = new FormData();
      formData.append("imgfile", e.file);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      uploadImage(formData).then((res) => {
        if (res.result) {
          if(isType == 0) {
            this.formData.pic = res.url
          } else if(isType == 1) {
            this.formData.aipic1 = res.url;
          } else if(isType == 2) {
            this.formData.aipic2 = res.url;
          } else if(isType == 3) {
            this.formData.aipic3 = res.url;
          }
        }
        Toast.clear();
      });
    },

    query() {
      let { formData, id, attrName } = this;
      // formData.pic = this.imgSplit(formData.pic);
      let params = formData;
      if (attrName == "") {
        this.$toast("请选择属性标签");
        return false;
      }
      if (formData.attrvalue == "") {
        this.$toast("请填写属性标签值");
        return false;
      }
      if (formData.numtype == "") {
        this.$toast("请选择价格变动类型");
        return false;
      }
      if (formData.num === "") {
        this.$toast("请填写价格变动值");
        return false;
      }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      if (id) {
        params.id = id;
        editShopCommodityAttr(params).then((res) => {
          let data = res;
          if (data.result) {
            setTimeout(() => {
              Toast.clear();
              this.$toast.success(data.message);
            }, 500);
            // setTimeout(() => {
            //   history.back();
            // }, 1500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      } else {
        addShopCommodityAttr(params).then((res) => {
          let data = res;
          if (data.result) {
            // setTimeout(() => {
            //   Toast.clear();
            //   this.$toast.success(data.message);
            // }, 2000);
            setTimeout(() => {
              Toast.clear();
              history.back();
            }, 500);
          } else {
            this.$toast.fail(data.message || "服务器报错，请稍后～");
          }
        });
      }
    },
    // 图片路径的分割
    imgSplit(url) {
      if (url != "" && url) {
        if (url.indexOf("upload")) {
          let splitArr = url.split("/upload/");
          return splitArr[splitArr.length - 1];
        } else if (url.indexOf("Upload")) {
          let splitArr = url.split("/Upload/");
          return splitArr[splitArr.length - 1];
        }
      } else {
        return "";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-top: 120px;
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .main_content {
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .block {
      margin-bottom: 80px;
      h1 {
        text-align: center;
        font-weight: 400;
        margin-bottom: 20px;
        font-size: 30px;
      }
      .img_box {
        margin: auto;
        margin-top: 40px;
        text-align: center;
      }
      p {
        font-size: 22px;
        text-align: center;
        &.red {
          color: #ff0012;
        }
      }
      .ai_images_wrap {
        width: 600px;
        margin: auto;
        .ai_images_item {
          .img_box {
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>